<template>
	<section>
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;"  @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.shopusername" @keyup.enter.native="getshopUsers" placeholder="账号"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getshopUsers " icon="el-icon-search">查询账号信息</el-button>
				</el-form-item>
				<el-form-item>
					<el-button v-if="User.UserLevel!=0" type="primary" @click="handleAdd">新增账号信息</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="shopusers" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column prop="Id" width="120" label="账号ID" >
			</el-table-column> -->
			<el-table-column prop="Number" label="账号" width="180" sortable>
			</el-table-column>
			<el-table-column prop="Name" label="账号名称" width="180" sortable>
			</el-table-column>
			
			<el-table-column prop="Password" label="账号密码 " width="120" sortable>
			</el-table-column>
			<el-table-column prop="UserLevel" label="账号级别" width="120" :formatter="formatlevel" sortable>
			</el-table-column>
			
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column >
			  <el-table-column prop="State" label="状态" width="120" >				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==2">停用</el-tag>
                  <el-tag type="success" size="medium" v-if="scope.row.State==1">启用</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column  label="变更状态" width="120" v-if="JSON.parse(this.getuserstate()).TenancyId==0">
				<template slot-scope="scope">			
				<el-switch :ref="shopusers[scope.$index].Id"   v-model="shopusers[scope.$index].BoolState"  active-color="#13ce66" inactive-color="#ff4949" @change="SwitchChange(scope.row)" ></el-switch>
				 </template>
			</el-table-column>
			<el-table-column label="操作" width="400" fixed="right">
				<template  slot-scope="scope">
					<el-button v-if="User.Id!=scope.row.Id&&User.UserLevel!=0" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="warning" size="small" v-if="TenancyId=='0'||TenancyId==null" @click="reset(scope.row)">重置密码</el-button>
					<el-button type="warning" size="small" v-if="TenancyId=='0'||TenancyId==null" @click="ShowChangeTwo(scope.row)">重置操作密码</el-button>
					<el-button type="warning" size="small" v-if="TenancyId=='0'||TenancyId==null" @click="RandomReset(scope.row)">随机操作密码</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑账号" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
				<el-form-item label="账号" prop="Number">
					<el-input v-model="editForm.Number" auto-complete="off" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="账号名称" >
					<el-input v-model="editForm.Name" auto-complete="off" ></el-input>
				</el-form-item>
			    <el-form-item label="账号密码" prop="Password" hidden>
					<el-input v-model="editForm.Password" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="账号级别" prop="UserLevel" v-if="TenancyId>0&&TenancyId!=null">
					<el-radio-group v-model="editForm.UserLevel">
						<el-radio class="radio" :label="1">管理员</el-radio>
						<el-radio class="radio" :label="0">前台</el-radio>
						<el-radio class="radio" :label="7">教练</el-radio>
						<el-radio class="radio" :label="6">财务</el-radio>
						<el-radio class="radio" :label="4">水质检测员</el-radio>
						<el-radio class="radio" :label="5">水电检测员</el-radio>						
					</el-radio-group>
				</el-form-item>
			
				</el-form-item>
					<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>
				<!-- <el-form-item label="生日">
					<el-date-picker type="date" placeholder="选择日期" v-model="editForm.birthday"></el-date-picker>
				</el-form-item>
				 -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="新增账号" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
				<el-form-item label="账号" prop="Number">
					<el-input v-model="addForm.Number" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="账号名称" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
			    <el-form-item label="账号密码" prop="Password">
					<el-input v-model="addForm.Password" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="账号级别" prop="UserLevel">
					<el-radio-group v-model="addForm.UserLevel">
						<el-radio class="radio" :label="1">管理员</el-radio>
						<el-radio class="radio" :label="0">前台</el-radio>
						<el-radio class="radio" :label="7">教练</el-radio>
						<el-radio class="radio" :label="6">财务</el-radio>
						<el-radio class="radio" :label="4">水质检测员</el-radio>
						<el-radio class="radio" :label="5">水电检测员</el-radio>							
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="TenancyId=='0'||TenancyId==null" label="门店列表" prop="ShopId">
                  <el-select filterable v-model="addForm.ShopId" placeholder="请选择门店">
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id" >
               </el-option>
                 </el-select>
				</el-form-item>
				
			
				</el-form-item>
					<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>

			<el-dialog title="修改密码" v-model="FormVisible" :close-on-click-modal="false" custom-class style="width:50%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;">
			<el-form :model="Form" label-width="100px" :rules="FormRules" ref="Form">
				<el-form-item label="新密码" prop="NewPwd">
					<el-input v-model="Form.NewPwd" type="password" placeholder="请输新密码" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="确认新密码" prop="Confirm">
					<el-input v-model="Form.Confirm" type="password" placeholder="确认新密码" auto-complete="off"></el-input>
				</el-form-item>					
		    </el-form>		 
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="FormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="resetPWD" >提交</el-button>
			</div>
			
		   </el-dialog>
			<el-dialog title="修改操作密码" v-model="FormVisible2" :close-on-click-modal="false" custom-class style="width:50%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;">
			<el-form  >
				<el-form-item >
					<el-input  v-model="TwoPassword"  placeholder="请输新操作密码" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item style="float:right">
									<el-button @click.native="FormVisible2 = false">取消</el-button>
				<el-button type="primary" @click.native="ChangeTwo" >提交</el-button></el-form-item>			
		    </el-form>				
		   </el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
import {mapGetters} from 'vuex';
	//import NProgress from 'nprogress'
	import {ChangeTwoPassword, RandomResetTwoPassword,getshopUser, removeshopUser, editshoptUser, addshopUser ,getShopInfor,userChangeState,ResetPassword} from '../../api/api';

	export default {
		data() {
			return {
				TwoChangeId:'',				
				TwoPassword:'',
				FormVisible2:false,
				filters: {
					shopusername: ''
				},
				Form:{
					UserId:'',
					NewPwd:'',
					Confirm:''
				},
				FormVisible:false,
                FormRules:{
					 NewPwd: [
						{ required: true, message: '请输入新密码', trigger: 'blur' }
					],
					Confirm: [
						{ required: true, message: '请再次输入新密码', trigger: 'blur' }
					],
				},
				TenancyId:'',
				User:{},
				options:[],
				shopusers: [],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列

				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Number: [
						{ required: true, message: '请输入账号', trigger: 'blur' },
						
					],

				},
				//编辑界面数据
				editForm: {
					Id: 0,
					Number: '',
					Name:'',
					Password:'123456',
                    UserLevel:'0',
					Remark:''
					
				},

				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Number: [
						{ required: true, message: '请输入账号', trigger: 'blur' }
					],
					Password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					]
					,
					UserLevel: [
						{ type:'number', required: true, message: '请选择账号级别'}
					],
					Name:[{
						required: true, message: '请输入名称', trigger: 'blur'
					}],
					ShopId: [
						{ required: true, message: '请选择门店', trigger: 'blur' }
					]
					
				},
				//新增界面数据
				addForm: {
					Number: '',
					Name:'',
					Password:'',
					UserLevel:'0',
					ShopId:'',
					Remark:'',
					TenancyId:''
				}
			}
		},
		methods: {
			ShowChangeTwo(value){this.FormVisible2=true;this.TwoChangeId='';this.TwoChangeId=value.Id;},
			ChangeTwo(){
				   if(this.TwoPassword==='')
				   {
								this.$message({
									message: '请输入新操作密码',
									type: 'error'
								});	
								return ;				   
				   }
			       let para={id:this.TwoChangeId,newPassword:this.TwoPassword}
				  ChangeTwoPassword(para).then((res)=>{
								let {Success,Msg}=res.data;
								if(Success)
								{
								this.$message({
									message: Msg,
									type: 'success'
								});
								this.FormVisible2=false;
								}
								else
								{
								this.$message({
									message: Msg,
									type: 'error'
								});
								}
              }).catch(error=>{
                 alert('网络错误');
                });			   
			},
           RandomReset(value){
			       let para={id:value.Id}
				  RandomResetTwoPassword(para).then((res)=>{
								let {Success,Msg,Data}=res.data;
								if(Success)
								{
        this.$alert(Data, '重置后的新操作密码', {
          confirmButtonText: '确定'
            });
								}
								else
								{
								this.$message({
									message: Msg,
									type: 'error'
								});
								}
              }).catch(error=>{
                 alert('网络错误');
                });			   
		   },
		   reset(row)
		   {
					 this.Form.Confirm='';
					 this.Form.NewPwd='';
				    this.Form.UserId=row.Id;
					this.FormVisible=true;
		   },
			resetPWD()
			{
                  
				let para={
					id:this.Form.UserId,
					firstPwd:this.Form.NewPwd,
					secondPwd:this.Form.Confirm
				}
				  ResetPassword(para).then((res)=>{
								let {Success,Msg}=res.data;
								if(Success)
								{
								this.$message({
									message: Msg,
									type: 'success'
								});
								this.FormVisible=false;
								}
								else
								{
								this.$message({
									message: Msg,
									type: 'error'
								});
								}
              }).catch(error=>{
                 alert('网络错误');
                });
			},
			 SwitchChange(row){
                // console.log(1);
			   row.State=row.BoolState==true?1:2;			 
                let para={
                    id:row.Id
                }
              userChangeState(para).then((res)=>{
              }).catch(error=>{
                 alert('网络错误');
                });
            },
			...mapGetters(['getuserstate']),
			//转换
			formatlevel: function (row, column) {
				return row.UserLevel ==1 ? '管理员' : row.UserLevel == 0 ? '前台' : row.UserLevel == 3 ? '一卡通账号':row.UserLevel == 4 ? '水质监测员':row.UserLevel == 5 ? '水电监测员':row.UserLevel == 6 ? '财务':row.UserLevel == 7 ? '教练':'未知';
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getshopUsers();
			},
			//获取用户列表
			 getshopUsers () {
				 this.TenancyId=JSON.parse(this.getuserstate()).TenancyId;
				 this.User=JSON.parse(this.getuserstate());
				let para = {
					PageIndex: this.page-1,
					
					PageSize:10,
					ShopId:JSON.parse(this.getuserstate()).TenancyId,
					Number:this.filters.shopusername,

				};
				this.listLoading = true;
				//NProgress.start();

				getshopUser(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//  console.log(res);
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					// this.total = res.data.total;
					this.shopusers = res.data.Data;
				   this.total=res.data.TotleCount;
					// this.users.filter((u, index) => index < 20 * this.page && index >= 20 * (this.page - 1));
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
			//获取门店列表
			getShop(){
				let para={
                   
				}
                 getShopInfor(para).then((res)=>{
                        this.options=res.data;
				 }).catch(error=>{

				 })
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.id };
					removeshopUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this. getshopUsers ();
					});
				}).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
				this.editForm.Password='123456';
			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					Number: '',
					Name:'',
					Password:'',
					UserLevel:0,
			     	ShopId:'',
					Remark:'',
					TenancyId:JSON.parse(this.getuserstate()).TenancyId,
					
				};
				 if(this.TenancyId=='0'||this.TenancyId==null)
				 {
				   this.getShop();

				 }  
			},
			//编辑
			editSubmit: function () {
				if(this.editForm.UserLevel==-1)
				{

				}
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							// para.birthday = (!para.birthday || para.birthday == '') ? '' : util.formatDate.format(new Date(para.birthday), 'yyyy-MM-dd');
							editshoptUser(para).then((res) => {
								this.editLoading = false;
								let {Success,Msg}=res.data;
								if(Success)
								{
								this.$message({
									message: Msg,
									type: 'success'
								});
								}
								else
								{
								this.$message({
									message: Msg,
									type: 'error'
								});
								}
								//NProgress.done();

								// this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this. getshopUsers ();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
							if(this.TenancyId=='0'||this.TenancyId==null)
							{}else{
								this.addForm.ShopId=this.TenancyId;
							}
							let para = Object.assign({}, this.addForm);
						
							addshopUser(para).then((res) => {
								
								let { Success,Msg } = res.data;
								this.addLoading = false;
								//NProgress.done();
								if(Success)
								{
                                  this.$message({
									message: Msg,
									type: 'success'
								        });
								}else
								{
                                    this.$message({
                                     message: Msg,
                                  type: 'error'
                                    });
								}
								
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this. getshopUsers ();
							}) .catch(error=>{
                            alert('系统错误');
                            });
							
							
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchremoveshopUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this. getshopUsers ();
					});
				}).catch(() => {

				});
			}
		}
		,
		mounted() {
			this. getshopUsers ();
		}
	}

</script>


// WEBPACK FOOTER //
// ShopUser.vue?89ccbfa2